import React, { Component } from 'react';

class Contact extends Component {
  render() {

    if(this.props.data){
      var message = this.props.data.contactmessage;
      var social = this.props.data.social;
    }

    return (
      <section id="contact">

         <div className="row section-head">

            <div className="two columns header-col">

               <h1><span>Get In Touch.</span></h1>

            </div>

            <div className="ten columns">

                  <p className="lead">{message}</p>
                  <p className="address">
                     {social && social.map(s => (
                       <span key={s.name}><a href={s.url} target="_blank" rel="noopener noreferrer"><i className={s.className}></i> {s.name.charAt(0).toUpperCase() + s.name.slice(1)}</a><br /></span>
                     ))}
                  </p>
            </div>

         </div>
       </section>
    );
  }
}

export default Contact;
